import React from 'react';

import styled from '@emotion/styled';

interface RatingMetricsLegendProps {
  colorObj: Record<string, string>;
  label: string;
}
const RatingMetricsLegend: React.FC<RatingMetricsLegendProps> = ({
  colorObj,
  label,
}) => {
  return (
    <LegendsArea>
      <XLabel>{label}</XLabel>
      <CellArea>
        {Object.keys(colorObj).map((data, index) => (
          <StarCell key={index}>
            <ColorBox
              style={{ backgroundColor: colorObj[`${index + 1}`] }}
            ></ColorBox>
            {index + 1} Star{index > 1 ? 's' : ''}
          </StarCell>
        ))}
      </CellArea>
    </LegendsArea>
  );
};

export default RatingMetricsLegend;

const CellArea = styled.div`
  display: flex;
  gap: 20px;
`;

const StarCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
`;

const ColorBox = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
`;

const LegendsArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 10px;
  margin-top: -12px;
`;

const XLabel = styled.div`
  font-weight: 400;
  margin-bottom: 12px;
  color: #6e7079;
`;
